import { requestLogin } from '../../services/request-login';

import { upload, TYPE_IMAGE } from '../../actions/upload';
import { updateMember } from '../members/actions';
import { getViewedMember, getCurrentMemberId } from '../members/selectors';
import { rolesActionClicked, customRolesActionsMap, openRoleModal } from '../roles/actions';
import { resizeImage } from '../../services/resize-image';
import { navigateToHomePage } from '../../services/wix-sdk-utils';
import { getIsMobile } from '../site/selectors';
import { toBIBoolean } from '../../services/bi';
import { CHAT_APP_DEF_ID } from '../../constants/apps';
import * as modalActions from '../../actions/open-modal';

const EDIT_MODAL_PROPS = { width: '320px', height: '100%' };

export const SET_PROFILE_PICTURE_LOADING = 'profilePage/SET_PROFILE_PICTURE_LOADING';
export const SET_PROFILE_COVER_LOADING = 'profilePage/SET_PROFILE_COVER_LOADING';
export const SET_PROFILE_EDIT_NAME = 'profilePage/SET_PROFILE_EDIT_NAME';
export const SET_PROFILE_EDIT_PICTURE = 'profilePage/SET_PROFILE_EDIT_PICTURE';
export const SET_PROFILE_EDIT_COVER = 'profilePage/SET_PROFILE_EDIT_COVER';
export const SET_PROFILE_SAVING = 'profilePage/SET_PROFILE_SAVING';
export const SET_PROFILE_EDITING = 'profilePage/SET_PROFILE_EDITING';

export const setProfilePictureLoading = (pictureLoading) => ({
  type: SET_PROFILE_PICTURE_LOADING,
  pictureLoading,
});
export const setProfileCoverLoading = (coverLoading) => ({
  type: SET_PROFILE_COVER_LOADING,
  coverLoading,
});
export const setProfileEditName = (editName) => ({
  type: SET_PROFILE_EDIT_NAME,
  editName,
});
export const setProfileEditPicture = (editPicture) => ({
  type: SET_PROFILE_EDIT_PICTURE,
  editPicture,
});
export const setProfileEditCover = (editCover) => ({
  type: SET_PROFILE_EDIT_COVER,
  editCover,
});
export const setProfileSaving = (isSaving, changed) => ({
  type: SET_PROFILE_SAVING,
  isSaving,
  changed,
});
export const setProfileEditing = (isEditing) => ({
  type: SET_PROFILE_EDITING,
  isEditing,
});

export const uploadProfilePicture = (image) => async (dispatch) => {
  dispatch(setProfilePictureLoading(true));
  const { dataUrl } = await resizeImage(image);
  dispatch(setProfileEditPicture({ file: dataUrl, name: image.name }));
  dispatch(setProfilePictureLoading(false));
};

export const uploadProfileCover = (image) => async (dispatch) => {
  dispatch(setProfileCoverLoading(true));
  const { dataUrl } = await resizeImage(image);
  dispatch(setProfileEditCover({ file: dataUrl, name: image.name }));
  dispatch(setProfileCoverLoading(false));
};

export const cancelProfileEditing = () => (dispatch) => {
  dispatch(setProfileEditing(false));
  dispatch(setProfileEditName(null));
  dispatch(setProfileEditCover(null));
  dispatch(setProfileEditPicture(null));
};

export const enterProfileEditing = () => (dispatch, getState) => {
  dispatch(setProfileEditing(true));
  if (getIsMobile(getState())) {
    dispatch(modalActions.openInternalUrlAsModal('app/profile', EDIT_MODAL_PROPS));
  }
};

export const openChat = (memberId) => (_dispatch, getState) => {
  const state = getState();
  const currentMemberId = getCurrentMemberId(state);

  if (!currentMemberId) {
    requestLogin();
    return;
  }

  Wix.SuperApps.getPublicAPI({ appDefinitionId: CHAT_APP_DEF_ID }, (api) => api.startPrivateChat(memberId));
};

export const saveProfile = () => async (dispatch, getState) => {
  const state = getState();
  const viewedMember = getViewedMember(state);
  const { editPicture, editCover, editName } = state.profilePage;
  const hasNameChanged = editName && editName.length > 0;
  const changes = {
    photo_changed: toBIBoolean(!!editPicture),
    name_changed: toBIBoolean(hasNameChanged),
  };
  const promises = [];

  if (editPicture) {
    promises.push(
      dispatch(upload(editPicture, TYPE_IMAGE))
        .then((file) => ({ picture: file }))
        .catch(() => dispatch(setProfileEditPicture(null))),
    );
  }

  if (editCover) {
    promises.push(
      dispatch(upload(editCover, TYPE_IMAGE))
        .then((file) => ({ cover: file }))
        .catch(() => dispatch(setProfileEditCover(null))),
    );
  }

  if (hasNameChanged) {
    promises.push(Promise.resolve({ name: editName }));
  }

  dispatch(setProfileEditing(false));

  if (promises.length > 0) {
    dispatch(setProfileSaving(true, changes));
    const editedFields = await Promise.all(promises);
    const fields = editedFields.reduce((acc, field) => ({ ...acc, ...field }), {});

    await dispatch(updateMember(viewedMember.uid, fields));
    dispatch(setProfileSaving(false));
    dispatch(modalActions.openNotification({ translationKey: 'profile-widget.saved-message' }));
  }
};

const onDeleteMember = () => (dispatch) => {
  dispatch(navigateToHomePage());
};

export const onRoleAction = (memberId, role) => (dispatch) => {
  dispatch(rolesActionClicked(memberId, role.roleId));

  if (customRolesActionsMap[role.roleId]) {
    return dispatch(customRolesActionsMap[role.roleId]({ memberId, onDeleteMember }));
  }

  return dispatch(openRoleModal(memberId, role));
};
